import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './Toggle.module.css';

/**
 * Toggle Switch Component
 * A simple on/off toggle switch
 */
function Toggle({ id, checked, onChange, label, disabled = false, className = '' }) {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`${styles.toggleContainer} ${className}`}>
      <label htmlFor={toggleId} className={styles.toggleLabel}>
        <input
          type="checkbox"
          id={toggleId}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={styles.toggleInput}
        />
        <span className={`${styles.toggleSwitch} ${disabled ? styles.disabled : ''}`}>
          <span className={styles.toggleSlider} />
        </span>
        {label && <span className={styles.labelText}>{label}</span>}
      </label>
    </div>
  );
}

Toggle.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Toggle.defaultProps = {
  id: undefined,
  onChange: undefined,
  label: undefined,
  disabled: false,
  className: '',
};

export default Toggle;

